
export const pastelBlue = "#00b195";
export const pastelOrange = "#ff8000";
export const pastelRed = "#ff3b00";
export const pastelDark = "#004a56";

export const textColor = '#474747';
export const textFamily = 'inter';

export const titleStyle = {
    fontSize: { xs: '32px', sm: '34px', md: '40px' }, lineHeight: '48px', fontFamily: "Quicksand", fontWeight: 700,
    zIndex: 12, color: textColor, textAlign: 'left', position: 'relative', textTransform: 'uppercase'
};

export const textStyle = {
    fontSize: '16px', fontFamily: textFamily, fontWeight: 400, zIndex: 12, color: textColor, textAlign: 'left', position: 'relative'
};

export const fullCenter = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center'
}

export const textInputSX = {
    width: '100%',
    minWidth: 'auto',
    '&:hover': {

    },
    // Label color (unfocused)
    "& .MuiInputLabel-root": {
        color: "gray",
    },
    // Label color when focused
    "& .MuiInputLabel-root.Mui-focused": {
        color: pastelOrange,
    },

    // The input text color
    "& .MuiInputBase-input": {
        color: "black",
    },

    // Underline (default)
    "& .MuiInput-underline:before": {
        color: pastelOrange,
    },

    // Underline on hover (when not disabled)
    "& .MuiInput-underline:hover:before": {
        color: `${pastelOrange} !important`,
    },

    // Underline when focused
    "& .MuiInput-underline:after": {
        color: `${pastelOrange} !important`,
        borderBottomColor: `${pastelOrange} !important`,
    },
    "& .MuiFormLabel-root.Mui-error": { color: pastelRed },
    "& .MuiFormHelperText-root.Mui-error": {
        color: pastelRed,
    },
};

export function generateUID(length = 8) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';

    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return result;
}

export function timestampToDateString(value, options = {}) {
    try {
        let date;

        // Firestore Timestamp
        if (value && typeof value.toDate === "function") {
            date = value.toDate();
        }
        // JS Date
        else if (value instanceof Date) {
            date = value;
        }
        // Milliseconds number
        else if (typeof value === "number") {
            date = new Date(value);
        }
        // ISO string
        else if (typeof value === "string") {
            const parsed = new Date(value);
            if (!isNaN(parsed.getTime())) date = parsed;
        } else if (value?.seconds || value?._seconds) {
            date = new Date((value?.seconds || value?._seconds) * 1000);
        }

        // Invalid fallback
        if (!date || isNaN(date.getTime())) return "";

        const dd = String(date.getDate()).padStart(2, "0");
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const yyyy = date.getFullYear();

        return `${dd}.${mm}.${yyyy}`;
    } catch (e) {
        console.error("Timestamp format error:", e);
        return "";
    }
}